import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import PalletsList from '../../components/pallets/Pallets/PalletsList';
import PalletsHeader from '../../components/pallets/Pallets/PalletsHeader';

import { useSessionContext } from '../../contexts/SessionContext';

export default function PalletsPage( props ){
    //console.debug("RTS Break PalletsPage");

    const {userAuthToken, apiRoot} = useSessionContext();

    const [data, setData] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);


    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/Pallets/GetAllPallets";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        fetchData();
    },[props, fetchData]);  
    

    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    
    return(
        <Box id="pageBox">
            <PalletsHeader />
            <Box sx={{mt:2}}>           
                <PalletsList data={data}/>
            </Box>
        </Box>
    );
}
